import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState, userFeatureKey } from './user.state';

export const selectUsersStateRoot =
  createFeatureSelector<UserState>(userFeatureKey);

export const selectUsers = createSelector(
  selectUsersStateRoot,
  (state) => state.users
);

export const selectLoading = createSelector(
  selectUsersStateRoot,
  (state) => state.loading
);

export const selectLoadFailed = createSelector(
  selectUsersStateRoot,
  (state) => state.loadFailed
);

export const selectVerifiedEmail = createSelector(
  selectUsersStateRoot,
  (state) => state.verifiedEmail
);

export const selectVerificationToken = createSelector(
  selectUsersStateRoot,
  (state) => state.verificationToken
);
